<template>
  <header class="header a-main-content" v-if="activeNews">
    <nav>
      <ul class="pagination">
        <li class="page-item prev" @click="onPrevNewsClick">
            <span class="page-link">
              <img src="@/assets/img/static/arrow-next-prev.png" alt="">
            </span>
        </li>
        <li class="page-item a-width-100-percent">
          <div class="news__container" v-if="showNews">
            <div class="news__cart border-bottom-0">
              <div class="news__header">
                <div class="news__title" v-html="escape(activeNews.title)"></div>
                <div class="news__time-date">
                  <date-time tag="span" :value="activeNews.publicationDate"></date-time>
                </div>
              </div>
              <div class="news__body a-container-form justify-content-between u-padding-bottom-0">
                <div class="news__text" v-html="escape(activeNews.briefDescription)"></div>
                <router-link class="gui-btn gui-btn--red gui-btn--w-150"
                             :to="{name: 'news-overview', params: { id: activeNews.id }}">
                  {{$t('form.news.more-details')}}
                </router-link>
              </div>
            </div>
            <button class="close" @click.prevent="onCloseClick">
              <span aria-hidden="true">
                <img src="@/assets/img/static/b-icon_close_x.svg">
              </span>
            </button>
          </div>
          <div class="news__container" v-else>
            <div class="news__cart">
              <div class="a-container-form a-group-btn justify-content-center">
                <button class="gui-btn gui-btn--red" @click.prevent="onHideActiveNewsClick">Скрыть эту новость</button>
                <button class="gui-btn gui-btn--white-border" @click.prevent="onCancelClick">Отменить</button>
              </div>
            </div>
          </div>
        </li>
        <li class="page-item next" @click="onNextNewsClick">
            <span class="page-link">
              <img src="@/assets/img/static/arrow-next-prev.png" alt="">
            </span>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
  export default {
    data: () => ({
      showNews: true,
      activeItemIdx: 0
    }),

    computed: {
      hiddenNews() {
        return _.orderBy(this.$store.getters.hiddenNews, 'publicationDate', 'desc');
      },

      fixedNews() {
        const allNews = this.$store.getters.fixedNews.items || [];
        return allNews.filter(news => {
          return !_.find(this.hiddenNews, {id: news.id});
        });
      },

      activeNews() {
        const item = _.get(this.fixedNews, this.activeItemIdx);
        if (!item) this.activeItemIdx = 0;
        return item;
      }
    },

    mounted() {
      this.$store.dispatch('fetchFixedNews');

      setInterval(() => {
        this.$store.dispatch('fetchFixedNews');
      }, 30000);
    },

    methods: {
      onCloseClick() {
        this.showNews = false;
      },

      onCancelClick() {
        this.showNews = true;
      },

      onPrevNewsClick() {
        this.activeItemIdx = (this.fixedNews.length + this.activeItemIdx - 1) % this.fixedNews.length;
      },

      onNextNewsClick() {
        this.activeItemIdx = (this.activeItemIdx + 1) % this.fixedNews.length;
      },

      onHideActiveNewsClick() {
        this.onCancelClick();
        this.$store.dispatch('hideActiveNews', {
          id: this.activeNews.id,
          until: this.activeNews.to
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    background-color: #FCDADC;
  }

  .news__container {
    position: relative;
    padding-right: 34px;

    .news__title {
      color: #E30613;
    }

    .close {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  .a-group-btn {
    .gui-btn {
      margin: 0px 8px;
    }
  }
</style>
